export enum TemperatureSensorOptionEnum {
    // WARM WATER enums
    WARM_WATER_TEMP_CIRCULATION = 'warm_water_temp_circulation',
    WARM_WATER_TEMP_BUFFER = 'warm_water_temp_buffer',
    WARM_WATER_TEMP_BOILER = 'warm_water_temp_boiler',
    WARM_WATER_TEMP_SOLAR = 'warm_water_temp_solar',
    FRESH_WATER_STATION_PRIMARY = 'fresh_water_station_primary',
    WARM_WATER_TEMP_OUTLET = 'warm_water_temp_outlet',
    CUSTOM_WATER = 'custom_water',

    // TEMPERATURE enums, all temperature values are number and followed by the 2 endings, meaning they are all pair values
    HEATER_CL = 'heater_cl',
    HEATER_BL = 'heater_bl',
    HEATER_BL_SECONDARY = 'heater_bl_secondary',
    HEATER_DH_PRIMARY = 'heater_dh_primary',
    HEATER_DH_SECONDARY = 'heater_dh_secondary',
    HEATER_SL_PRIMARY = 'heater_sl_primary',
    HEATER_SL_SECONDARY = 'heater_sl_secondary',
    HEATER_BLC = 'heater_blc',
    HEATER_BLC_SECONDARY = 'heater_blc_secondary',
    HEATER_WHLC = 'heater_whlc',
    HEATER_WHLC_SECONDARY = 'heater_whlc_secondary',
    HEATER_BRINE_LOOP = 'heater_brine_loop',
    HEATER_HPL = 'heater_hpl',
    HEATER_LH = 'heater_lh',
    CUSTOM_LOOP = 'custom_loop',
    COLLECTION_LOOP = 'collection_loop',

    // endings for some numbered enuns
    FLOW_TEMP = '-flow_temp',
    RETURN_TEMP = '-return_temp',
    FRESH_WATER_TEMP = '-fresh_water_temp'
}
